<template>
    <div v-if="background.length === 0" class="label" v-bind:class="{['bg-'+color]: color}"><slot></slot></div>
    <div v-else class="label" v-bind:style="{backgroundColor: background}"><slot></slot></div>
</template>
<script>
    export default {
        name: 'Label',
        components: {},
        props:  {
            color: {
                type: String,
                default: 'grey'
            },
            background: {
              type: String,
              default: ''
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./Label.scss" scoped lang="scss"></style>

